import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
    :root{
        --pink: #FF50A7;
        --darkblue: #32465B;
        --verde: #4BAFA7;
    }

    *{
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        outline: none;
        position: relative;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        font-smoothing: antialiased;
    }
    html{
        @media(max-width: 1080px){
            font-size: 93.75%; // 15px
        }
        @media(max-width: 720px){
            font-size: 87.5%; // 14px
        }
        scroll-behavior: smooth;
        
    }
    body{
        /*background: #EEEAE0;*/
        background: #f5f2ea;
        -webkit-font-smoothing: none;
        color: var(--darkblue);
        font-size: 0.85rem;
        overflow-x: hidden;
    }
    html, body, #root{ max-height: auto; height: 100%}
    button{
        cursor: pointer;
    }
    [disabled]{
        opacity: 0.6;
        cursor: not-allowed;
    }
    body, input, textarea, button, .react-datepicker{
        font-family: 'Roboto Condensed', Calibri, sans-serif;
        font-weight: 400;
    }
    h1, h2, h3, h4, h6{
        font-family: 'Lilita One', Calibri, cursive;
        font-weight: 400;
        text-transform: uppercase;
        font-style: italic;
        text-shadow: 1px 1px 2px rgba(0,0,0,0.15)
    }
    h2{
        font-size: 1rem
    }
    a{
        color: var(--pink)
    }

    .react-datepicker{
        text-transform: uppercase;
    }

    form{

        input, button{
            padding: 10px 15px;
            background: rgba(0,0,0,0.1);
            border: none;
            margin: 2px;
            border-radius: 4px 4px 5px 5px;
            width: 100%; 
            border-bottom: solid 1px rgba(0,0,0,0.05); 
            border-right: solid 1px rgba(0,0,0,0.05);    
            color: var(--darkblue); 
            font-weight : 500;

        }

        input[type=submit], button{
            text-transform: uppercase;
            font-weight: 900;
            background: var(--pink);
            color: #fff;
            font-size: 0.77rem;
            padding: 9px;
            margin-top: 5px;
            border-radius: 5px;
            box-shadow: 1px 1px 3px rgba(0,0,0,0.15); 
            cursor: pointer;
            &:hover{
                background: var(--darkblue);
                color: #fff;
            }
        }

        button.google{
            padding: 6px;
            background: #fff !important;
            color: var(--darkblue);
            display: flex;
            justify-content: center;
            align-items: center;
            &:hover{
                background: #EAEAEA;
                color: #0058A5;
            }
        }
    }

    /*tr.hover{ 
        
        div.hover {
            background-color: rgba(0,0,0,0.08);
            width: calc(100% - 100px);
            height: 45px;
            position: fixed;
            display: none;
            z-index: 9;
            border-radius: 7px;
            left: 86px;
            margin-top: -9px;
            pointer-events: none
        }
        div.ajuste { margin-top: -3px; }
        div.ajuste2 { margin-top: -0px; }

        &:hover{
            div.hover {display: block;}
        }
    }*/


    div.hover{
        transition: 0.9s;
        background: var(--darkblue);
        color: var(--pink);
        border-radius: 3px;
    }

    .estatistica{
        font-size: 0.75rem;
        font-size: 0.8rem;
        display: grid;
        grid-template-columns: auto auto;
        max-width: 100%;
        
        strong{ display:block; margin-right: 10px}
    }

    .close{
        background: #C30061;
        color: #fff;
        padding: 5px;
        border: 0;
        border-radius: 5px;
        line-height: 0.5rem;

        &:hover{
            background: var(--pink);
        }
        span{            
            font-weight: 900;
        }
    }


    button,
    .button {
        border-radius: 8px;
        border: none;
        padding: 8px 1px;
        font-weight: 900;
        text-transform: uppercase;
        margin: 2px 0;
        color: var(--darkblue);
        font-size: 0.70rem;
        background: rgba(0,0,0,0.03);
        /*
        white-space: nowrap;
        border: solid 1px rgba(0,0,0,0.05);
        */
        

        &:hover{
            transition: 0.9s;
            background: var(--darkblue);
            color: #fff;
        }
    }
    .add, .del {
        background: rgba(0,0,0,0.3);
        color: #fff;
        margin-top: 10px;
        font-size: 0.9rem;
        font-family: 'Lilita One', Calibri, cursive;  
        font-weight: 100;

        &:hover{
            background: var(--darkblue);
        }
    }
    .del {
        background: rgba(0,0,0,0.3);
        padding-left: 18px;
        padding-right: 18px;
    }

    textarea{
        border-radius: 6px;
        border: solid 1px rgba(0,0,0,0.4);
        display: block;
        padding: 10px;
        width: 100%;
        resize: none;
    }

    small{
        font-weight: 100;
        font-size: 0.7rem;
        text-transform: uppercase;
        color: rgba(0,0,0,0.8)
    }

    fieldset{
      border: dotted 1px rgba(0,0,0,0.1);
      padding: 0 5px;
      border-radius: 7px;
      margin-bottom: 10px;
      margin-top: 5px;
    }
    legend{
      width: auto;
      font-size: 0.75rem;
      text-transform: uppercase;
      background: #fff;
      padding: 2px 5px;
      border-radius: 10px;
      margin-bottom: 8px;
      border: dotted 1px rgba(0,0,0,0.1);
      color: var(--pink);
    }

    .semDefinicao{
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      padding: 0 0px;
      width: 100%;
      min-width: 44px;
      /*
      width: 1.2rem;
      height: 1.2rem;
      border-radius: 50%;
      border: solid 2px var(--darkblue);
      aspect-ratio: 1/1;
      box-shadow: 1px 1px 3px rgba(0,0,0,0.33), inset 1px 1px 2px rgba(0,0,0,0.33);
      opacity: 0.9;*/
    }
    .semDefinicao::after{
      content: 'NÃO MOSTRAR';
      width: 44px;
      white-space: break-spaces;
      position: absolute;
      text-align: center;
      /*width: 2px;
      height: 1.1rem;
      transform: rotate(45deg);
      background: var(--darkblue);
      box-shadow: 1px 1px 3px rgba(0,0,0,0.23)*/
    }
`;